var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((this.sections),function(item,index){return _c('section_list',{attrs:{"name":item.name,"id":item.id,"products":item.products}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }